import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AreaGateLogAdministrationComponent } from './area-gate-log-administration/area-gate-log-administration.component';
import { CommonFormattingModule, CommonLayoutModule, CommonTranslationModule, CommonUIButtonsModule, CommonUIFieldsModule } from '@sdbn/common';
import { AppClientResourcesModule, MaterialModule } from '@sdbn/appclient';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    AreaGateLogAdministrationComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIFieldsModule,
    CommonTranslationModule,
    MaterialModule,
    ReactiveFormsModule,
    AppClientResourcesModule,
    CommonFormattingModule,
    CommonUIButtonsModule
],
  exports: [
    AreaGateLogAdministrationComponent
  ]
})
export class AreaGateLogAdministrationModule { }
